import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { CookieService, UtilityService } from '@collab/comp-library';
import { Idle } from '@ng-idle/core';
import { AuthenticationService } from './pages/login/service/authentication.service';
import { ContactUsService } from './shared/component/contact-us/service/contact-us.service';
import { AuthService } from './shared/services/auth.service';


@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
    public navbarItems = ['Dashboard', 'Requirement', 'Test Design', 'Data management', 'Test execution', 'Reports'];
    public idleDuration = Number(environment.idleTimeout);
    public idleWarningDuration = Number(environment.idleWarningTimeout);
    public isContactUsShow= false;

    constructor(private authenticationService: AuthenticationService, private router: Router, private idle: Idle, private utilityService: UtilityService,
        public cookieService: CookieService, public contactUsService: ContactUsService, private authService: AuthService ) {
    }

    public ngOnInit(): void {
        this.utilityService.setEnvironmentVariable(environment.apiUrl);
        // to prevent session timeout model on login page

        //todo: removed for now , testing IAM without idle timeout
        // this.router.events.subscribe(() => {
        //     if (this.router.url.search(/login/) === -1) {
        //         this.idle.watch();
        //     } else {
        //         this.idle.stop();
        //     }
        // });

        this.isContactUsShow = this.contactUsService.isContactUsShow;
    }

    /**
     *
     * this method will direct the url to login page
     * @return { boolean }
     * @memberof AppComponent
     */
    public isLoginRoute(): boolean {
        return this.router.url.includes('/login') || this.router.url.includes('password-reset-page');
    }

    public isLandingRoute(): boolean {
        return this.router.url.includes('/landing-page');
    }

    /**
     * Logout of application on idle timeout
     */
    public onIdleTimeout() {
        this.authService.logout();
    }

    public onLogout() {
        this.authService.logout();
    }
}
